import { faGear } from '@fortawesome/pro-solid-svg-icons';
import { ComponentProps } from 'react';

import { useTranslate } from '@growtherapy/i18n';
import { MenuItem } from '@growtherapy/sprout-ui';

import { IconMenuItem } from '../../components/IconMenuItem';

export type VisitorSettingsDrawerMenuItemProps = {
  drawerId: string;
  isSettingsDrawerOpen: boolean;
  className?: string;
} & Pick<ComponentProps<typeof MenuItem>, 'onClick'>;

export function VisitorSettingsDrawerControlMenuItem({
  className,
  drawerId,
  isSettingsDrawerOpen,
  onClick,
}: VisitorSettingsDrawerMenuItemProps) {
  const t = useTranslate();
  return (
    <IconMenuItem
      aria-controls={drawerId}
      aria-expanded={isSettingsDrawerOpen}
      onClick={onClick}
      className={className}
      icon={faGear}
    >
      <span className='sr-only'>
        {isSettingsDrawerOpen
          ? t('telehealth-core:settings.closeSettings')
          : t('telehealth-core:settings.openSettings')}
      </span>
      <span aria-hidden>{t('telehealth-core:settings.settings')}</span>
    </IconMenuItem>
  );
}
